// extracted by mini-css-extract-plugin
export var cards = "linklist-module--cards--f303f";
export var home = "linklist-module--home--25df2";
export var image = "linklist-module--image--0dd60";
export var inner = "linklist-module--inner--03c25";
export var link = "linklist-module--link--e5987";
export var linkInner = "linklist-module--link-inner--91203";
export var links = "linklist-module--links--63a10";
export var llTeaser = "linklist-module--ll-teaser--f460d";
export var llTitle = "linklist-module--ll-title--32e0e";
export var text = "linklist-module--text--7fde0";
export var title = "linklist-module--title--6f8de";